import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsServiceHubsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'customer-service-helpcenter',
	path: '/jira/helpcenter',
};
